import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  tripCancellationTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tripCancellationTooltip',
    defaultMessage: 'Please note that Trip Cancellation is only for reimbursement of trip expenses, in the event that you need to cancel your trip before you leave home. It is not for Travel Delay or Trip Interruption or Missed Connection costs incurred whilst traveling. It is also not for reimbursement of medical expenses incurred whilst traveling.',
  },

  reasonsForTripCancellation: {
    id: 'fastCover.tripCancellationCFStep.reasonsForTripCancellation',
    defaultMessage: 'Reasons for Trip Cancellation',
  },

  reasonsForTripCancellationTooltip: {
    id: 'fastCover.tripCancellationCFStep.reasonsForTripCancellationTooltip',
    defaultMessage: `Please select a Reason from the list below. If you can find a Reason below, then you are likely better off claiming on this Reason, as you may be reimbursed all or most of your expenses.
IF you don't find a Reason below AND you have taken "Cancellation For Any Reason" cover, then you can claim under that radio button option (see at the end of the list below). "Cancellation For Any Reason" covers you for ANY cancellation reason, but normally covers you at a LOWER RATE of cost reimbursement.`,
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  haveYouReceivedReimbursementTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.haveYouReceivedReimbursementTooltip',
    defaultMessage: 'Please enter here any amount that you have received, or will receive, from another party. This could be a Travel Supplier (airline/hotel/travel agent etc) OR from another Insurer (e.g. from your Credit Card). The amount that you enter here will be deducted from the amount that we may reimburse you.',
  },

  travelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  travelInterruptionTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelInterruptionTooltip',
    defaultMessage: 'Trip Interruption should be claimed for only after you have started your trip. Your plan will have a minimum number of hours that you need to be delayed, before you can claim on Trip Interruption.',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons1',
    defaultMessage: 'Death of Insured, Traveling Companion, or Family member (traveling or non-traveling)',
  },

  reasons2: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons2',
    defaultMessage: 'Sickness or Accidental Injury of insured, Traveling Companion, or Family Member (traveling or non-traveling)',
  },

  reasons3: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons3',
    defaultMessage: 'Death or Hospitalization of the Host at Destination',
  },

  reasons4: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons4',
    defaultMessage: 'Termination or lay-off',
  },

  reasons5: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons5',
    defaultMessage: 'Transfer of employment',
  },

  reasons6: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons6',
    defaultMessage: 'Emergency duty recall',
  },

  reasons7: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons7',
    defaultMessage: 'Cancellation of services of a Common Carrier - due to weather or strike',
  },

  reasons8: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons8',
    defaultMessage: 'Uninhabitable accommodations',
  },

  reasons9: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons9',
    defaultMessage: 'Terrorist Incident',
  },
  reasons10: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons10',
    defaultMessage: 'You or Your Traveling Companion are a victim of a felonious assault',
  },

  reasons11: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons11',
    defaultMessage: 'Hijack, Quarantine, Jury duty, or subpoena, Uninhabitable Home',
  },

  reasons12: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons12',
    defaultMessage: 'Directly involved in a traffic accident ',
  },

  reasons13: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons13',
    defaultMessage: 'Bankruptcy or Default of a Travel Supplier',
  },

  // reasons14: {
  //   id: 'fastCover.stepTripCancellationAndTripInterruption.reasons14',
  //   defaultMessage: 'Strike causing cessation of services of the Common Carrier',
  // },

  reasons15: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons15',
    defaultMessage: 'Other',
  },

  noneOfTheAbove: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.noneOfTheAbove',
    defaultMessage: 'None of the Above (Cancel For Any Reason)',
  },

  noneOfTheAboveTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.noneOfTheAboveTooltip',
    defaultMessage: 'Please use this option if NONE OF THE ABOVE reasons apply for you. "Cancellation For Any Reason" covers you for ANY cancellation reason, but normally covers you at a LOWER RATE of cost reimbursement, than for the reasons listed above.',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformation',
    defaultMessage: 'Loss Information',
  },

  lossInformationPerPerson: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformationPerPerson',
    defaultMessage: 'Loss Information (per person)',
  },

  addLossInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonForInterruption',
    defaultMessage: 'Other reasons for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  amountClaimed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayInformation',
    defaultMessage: 'Travel Delay Information',
  },

  youHaveExperiencedATripDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.youHaveExperiencedATripDelay',
    defaultMessage: 'You have experienced a Trip Delay if you were delayed enroute to or from your destination for the hours stated in your policy. This is most commonly a 12 hour delay.',
  },

  addDelayInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  originAirport: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.originAirport',
    defaultMessage: 'Origin Airport',
  },
  destinationAirport: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.destinationAirport',
    defaultMessage: 'Destination Airport',
  },
  scheduledDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledDeparture',
    defaultMessage: 'Scheduled Departure',
  },
  scheduledOut: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledOut',
    defaultMessage: 'Scheduled Out',
  },
  scheduledIn: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledIn',
    defaultMessage: 'Scheduled In',
  },
  departureDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.departureDelay',
    defaultMessage: 'Departure Delay (mins)',
  },
  arrivalDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.arrivalDelay',
    defaultMessage: 'Arrival Delay (mins)',
  },
  status: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.status',
    defaultMessage: 'Flight Status',
  },
  cancelled: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cancelled',
    defaultMessage: 'Was the flight cancelled?',
  },
  tourGuide: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  notReported: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.currency',
    defaultMessage: 'Currency',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.detailsRegardingYourTripDelay',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  dateOfExpenses: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  insureds: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addInsured',
    defaultMessage: 'Name(s) and birth dates of all claimants:',
  },
  travelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonForCancellation',
    defaultMessage: 'Other reasons for cancellation',
  },

  tripCancellationForAnyReason: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.tripCancellationForAnyReason',
    defaultMessage: 'Are you claiming Trip Cancellation for Any Reason?',
  },
  addInsured: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addInsured',
    defaultMessage: 'Add Insured',
  },
  birthDay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.birthDay',
    defaultMessage: 'Birth Day',
  },
  fullName: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.fullName',
    defaultMessage: 'Full Name',
  },
  insuredInformationWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  travelSupplierWithIdx: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelSupplierWithIdx',
    defaultMessage: 'Travel Supplier Information {idx}',
  },
  addSupplier: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.addSupplier',
    defaultMessage: 'Add Supplier',
  },
  expenseFor: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },

  missedConnection: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.missedConnection',
    defaultMessage: 'Are you claiming for Missed Connection?',
  },

  missedConnectionTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.missedConnectionTooltip',
    defaultMessage: 'You have experienced a Missed Connection if your initial delay was 12 hours or more and caused you to miss a connecting flight OR If your delay caused you to miss your tour or cruise departure.',
  },

  travelDelay: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  travelDelayTooltip: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.travelDelayTooltip',
    defaultMessage: 'Travel Delay is for when, during your trip, you get delayed beyond your planned travel dates',
  },

  missedConnectionInformation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.missedConnectionInformation',
    defaultMessage: 'Missed Connection Information',
  },

  reasonsForMissedConnection: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.reasonsForMissedConnection',
    defaultMessage: 'Reasons for Missed Connection',
  },

  scheduledDateOfDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledDateOfDeparture',
    defaultMessage: 'Scheduled date of departure',
  },

  scheduledTimeOfDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledTimeOfDeparture',
    defaultMessage: 'Scheduled time of departure',
  },

  actualDateOfDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.actualDateOfDeparture',
    defaultMessage: 'Actual date of departure',
  },

  actualTimeOfDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.actualTimeOfDeparture',
    defaultMessage: 'Actual time of departure',
  },

  scheduledDateOfArrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledDateOfArrival',
    defaultMessage: 'Scheduled date of arrival',
  },

  scheduledTimeOfArrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.scheduledTimeOfArrival',
    defaultMessage: 'Scheduled time of arrival',
  },

  actualDateOfArrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.actualDateOfArrival',
    defaultMessage: 'Actual date of arrival',
  },
  actualTimeOfArrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.actualTimeOfArrival',
    defaultMessage: 'Actual time of arrival',
  },
  didTheDelayOccurDuringDeparture: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.didTheDelayOccurDuringDeparture',
    defaultMessage: 'Did the delay occur during departure?',
  },
  didTheDelayOccurDuringArrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.didTheDelayOccurDuringArrival',
    defaultMessage: 'Did the delay occur during arrival?',
  },
  detailsRegardingYourMissedConnection: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.detailsRegardingYourMissedConnection',
    defaultMessage: 'Details regarding your Missed Connection',
  },
  dateOfLoss: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.delayItem.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },
  flightNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.flightNumber',
    defaultMessage: 'Flight Number',
  },
  flightDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.flightDate',
    defaultMessage: 'Flight Date',
  },
  checkFlightDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.checkFlightDate',
    defaultMessage: "'{defaultMessage}' cannot be more than 1 year in the past or future.",
  },
  checkFlightNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.checkFlightNumber',
    defaultMessage: "'{defaultMessage}' Format: 2 letters + 1–4 digits (regex).",
  },
  flightDetails: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.flightDetails',
    defaultMessage: 'Flight Details',
  },
  searchSuccess: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.searchSuccess',
    defaultMessage: 'Search Success',
  },
  departure: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.departure',
    defaultMessage: 'Departure',
  },
  arrival: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.arrival',
    defaultMessage: 'Arrival',
  },
  pendingFlightApiRequest: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.pendingFlightApiRequest',
    defaultMessage: 'Searching for flight details, please wait a moment...',
  },

  flightSearchRequiredFields: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.requiredFields',
    defaultMessage: 'Please complete all required fields.',
  },
  flightNotFound: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.notFound',
    defaultMessage: "We couldn't find a flight with the provided information. Please check the number and date.",
  },
  invalidFlightNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.invalidNumber',
    defaultMessage: 'Flight number must follow the format: AA123.',
  },
  apiError: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.apiError',
    defaultMessage: "We couldn't connect to the flight verification system. Please try again later.",
  },
  useFlightInfo: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.useInfo',
    defaultMessage: 'Use this flight information for my claim',
  },
  pleaseEnterYourFlightNumberAndDateBelow: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.pleaseEnterYourFlightNumberAndDateBelow',
    defaultMessage: 'Please enter your flight number and date below',
  },
  manuallyEnterFlight: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.manuallyEnterFlight',
    defaultMessage: 'Manually Enter Flight',
  },
  typeOfTransport: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.typeOfTransport',
    defaultMessage: 'Type of Transport',
  },
  airline: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.airline',
    defaultMessage: 'Airline',
  },
  other: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.other',
    defaultMessage: 'Other',
  },
  cruiseLine: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cruiseLine',
    defaultMessage: 'Cruise Line',
  },
  cruiseNumber: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.cruiseNumber',
    defaultMessage: 'Cruise Number',
  },
  departureDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.departureDate',
    defaultMessage: 'Departure Date',
  },
  arrivalDate: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.arrivalDate',
    defaultMessage: 'Arrival Date',
  },
  departurePort: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.departurePort',
    defaultMessage: 'Departure Port',
  },
  arrivalPort: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.arrivalPort',
    defaultMessage: 'Arrival Port',
  },
  pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled',
    defaultMessage: 'Please describe details of your journey and what was cancelled',
  },
  transportService: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.transportService',
    defaultMessage: 'Transport Service',
  },
  departureLocation: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.departureLocation',
    defaultMessage: 'Departure Location',
  },
  destination: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.destination',
    defaultMessage: 'Destination',
  },
  descriptionOfTravelType: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.descriptionOfTravelType',
    defaultMessage: 'Description of travel type',
  },
  descriptionOfEvent: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.descriptionOfEvent',
    defaultMessage: 'Description of event',
  },

  // reason for trip cancellation ver 14
  sicknessOrInjury: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.sicknessOrInjury',
    defaultMessage: 'Sickness or injury',
  },

  death: {
    id: 'app.containers.FastCover.ChangesToYourJourney.death',
    defaultMessage: 'Death',
  },
  employmentTransfer: {
    id: 'app.containers.FastCover.ChangesToYourJourney.employmentTransfer',
    defaultMessage: 'Employment transfer, termination, or layoff',
  },
  calledToActiveDuty: {
    id: 'app.containers.FastCover.ChangesToYourJourney.calledToActiveDuty',
    defaultMessage: 'Called to Active Duty',
  },
  requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness: {
    id: 'app.containers.FastCover.ChangesToYourJourney.requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness',
    defaultMessage: 'Required to serve on a jury, subpoenaed, require to serve as a witness',
  },
  hijackedVictimOfFeloniousAssault: {
    id: 'app.containers.FastCover.ChangesToYourJourney.hijackedVictimOfFeloniousAssault',
    defaultMessage: 'Hijacked, Victim of Felonious Assault',
  },
  weatherOrDisaster: {
    id: 'app.containers.FastCover.ChangesToYourJourney.weatherOrDisaster',
    defaultMessage: 'Weather or Natural Disaster resulting in road closure or stoppage to public transportation preventing you from reaching your destination',
  },
  trafficAccident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.trafficAccident',
    defaultMessage: 'Traffic Accident you are involved in or delayed by preventing you from reaching your destination',
  },
  bankruptcyOfTravelSupplier: {
    id: 'app.containers.FastCover.ChangesToYourJourney.bankruptcyOfTravelSupplier',
    defaultMessage: 'Bankruptcy of Travel Supplier',
  },
  travelServiceCessation: {
    id: 'app.containers.FastCover.ChangesToYourJourney.travelServiceCessation',
    defaultMessage: 'Cessation of travel service due to Strike, Mechanical Breakdown, or Weather',
  },
  naturalDisasterResidence: {
    id: 'app.containers.FastCover.ChangesToYourJourney.naturalDisasterResidence',
    defaultMessage: 'Natural Disaster causing Uninhabitable conditions to your Primary Residence or Destination',
  },
  terroristIncident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.terroristIncident',
    defaultMessage: 'Terrorist Incident causing cessation/ or at your destination',
  },
  whoSickOrInjuredCusingTheCancellation: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whoSickOrInjuredCusingTheCancellation',
    defaultMessage: 'Who was sick or injured, causing the cancellation?',
  },
  oneOfTravelers: {
    id: 'app.containers.FastCover.ChangesToYourJourney.oneOfTravelers',
    defaultMessage: 'One of the travelers',
  },

  familyMemberOfTraveler: {
    id: 'app.containers.FastCover.ChangesToYourJourney.familyMemberOfTraveler',
    defaultMessage: 'A family member of a traveler',
  },

  hostAtDestination: {
    id: 'app.containers.FastCover.ChangesToYourJourney.hostAtDestination',
    defaultMessage: 'The host at the destination',
  },

  someoneElse: {
    id: 'app.containers.FastCover.ChangesToYourJourney.someoneElse',
    defaultMessage: 'Someone else',
  },

  statementOfAttendingPhysicianTemplate: {
    id: 'app.containers.FastCover.ChangesToYourJourney.statementOfAttendingPhysicianTemplate',
    defaultMessage: 'On clicking the button an email with a template Statement of Attending Physician will be sent to you. Please forward this to your physician and attach it along with other Supporting Documents for this claim',
  },
  statementOfAttendingPhysician: {
    id: 'app.containers.FastCover.ChangesToYourJourney.statementOfAttendingPhysician',
    defaultMessage: 'Statement of Attending Physician',
  },
  chooseAnInsured: {
    id: 'app.containers.FastCover.ChangesToYourJourney.chooseAnInsured',
    defaultMessage: 'Choose an insured:',
  },
  relationshipToTraveler: {
    id: 'app.containers.FastCover.ChangesToYourJourney.relationshipToTraveler',
    defaultMessage: 'Relationship to the traveler',
  },
  pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled: {
    id: 'app.containers.FastCover.ChangesToYourJourney.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
    defaultMessage: 'Please explain why this injury or sickness caused the trip to be cancelled',
  },
  whoHadDiedCausingTheCancellation: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whoHadDiedCausingTheCancellation',
    defaultMessage: 'Who died, causing the cancellation?',
  },
  dateOfDeath: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateOfDeath',
    defaultMessage: 'Date of death',
  },
  nameOfEmployer: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfEmployer',
    defaultMessage: 'Name of Employer',
  },

  whenWereYouNotified: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whenWereYouNotified',
    defaultMessage: 'When were you notified?',
  },

  dateOfTerminationOrLayoff: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateOfTerminationOrLayoff',
    defaultMessage: 'Date of termination or layoff (last working day)',
  },

  howLongWereYouEmployed: {
    id: 'app.containers.FastCover.ChangesToYourJourney.howLongWereYouEmployed',
    defaultMessage: 'How long were you employed (months)?',
  },

  wasThisWorkTransfer: {
    id: 'app.containers.FastCover.ChangesToYourJourney.wasThisWorkTransfer',
    defaultMessage: 'Was this a work transfer?',
  },
  nameOfServiceCallingToActiveDuty: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfServiceCallingToActiveDuty',
    defaultMessage: 'Name of Service calling to Active Duty',
  },

  dateYouBecame: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateYouBecame',
    defaultMessage: 'Date you became active duty',
  },
  nameOfCourtOrAuthority: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfCourtOrAuthority',
    defaultMessage: 'Name of court or legal authority',
  },

  dateToAppearInCourt: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateToAppearInCourt',
    defaultMessage: 'Date to appear in court',
  },
  nameOfAuthorityHandlingTheIncident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfAuthorityHandlingTheIncident',
    defaultMessage: 'Name of Authority handling the incident',
  },
  dateOfIncident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateOfIncident',
    defaultMessage: 'Date of Incident',
  },
  nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure',
    defaultMessage: 'Name of department of transportation or local government substantiating closure',
  },
  dateOfTransportClosureIncident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateOfTransportClosureIncident',
    defaultMessage: 'Date of transport closure incident (closest to your departure date)',
  },
  dateOfTrafficAccident: {
    id: 'app.containers.FastCover.ChangesToYourJourney.dateOfTrafficAccident',
    defaultMessage: 'Date of Traffic Accident',
  },
  nameOfTravelSupplier: {
    id: 'app.containers.FastCover.ChangesToYourJourney.nameOfTravelSupplier',
    defaultMessage: 'Name of Travel Supplier',
  },
  whenDidOperationsResume: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whenDidOperationsResume',
    defaultMessage: 'When did travel operations resume?',
  },
  whatCausedTheServiceCessation: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whatCausedTheServiceCessation',
    defaultMessage: 'What caused the service cessation?',
  },
  strikeOfACommonCarrier: {
    id: 'app.containers.FastCover.ChangesToYourJourney.strikeOfACommonCarrier',
    defaultMessage: 'Strike of a common carrier',
  },

  mechanicalBreakdownOfCommonCarrier: {
    id: 'app.containers.FastCover.ChangesToYourJourney.mechanicalBreakdownOfCommonCarrier',
    defaultMessage: 'Mechanical Breakdown of common carrier',
  },

  inclementWeatherOrNaturalDisaster: {
    id: 'app.containers.FastCover.ChangesToYourJourney.inclementWeatherOrNaturalDisaster',
    defaultMessage: 'Inclement weather or natural disaster',
  },
  primaryResidence: {
    id: 'app.containers.FastCover.ChangesToYourJourney.primaryResidence',
    defaultMessage: 'Primary Residence',
  },
  whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable',
    defaultMessage: 'When was the Primary Residence or Destination deemed uninhabitable?',
  },
  whereWasUninhabitable: {
    id: 'app.containers.FastCover.ChangesToYourJourney.whereWasUninhabitable',
    defaultMessage: 'Where was uninhabitable?',
  },
  provideDetailsOfTheIncident: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.provideDetailsOfTheIncident',
    defaultMessage: 'Provide full details of the incident including where and when it occurred, and why your travel service was cancelled including flight or cruise details',
  },
  equalAmountClaimNote: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.equalAmountClaimNote',
    defaultMessage: 'The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page “What Happened”. If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.',
  },
  pleaseSelectYourFlightBelow: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.pleaseSelectYourFlightBelow',
    defaultMessage: 'Plsease select your flight below:',
  },
  didYourInitialFlightDelayCauseAMissedConnection: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.didYourInitialFlightDelayCauseAMissedConnection',
    defaultMessage: 'Did your initial flight delay cause a missed connection?',
  },
  didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise: {
    id: 'fastCover.stepTripCancellationAndTripInterruption.didYourMissedConnectionCauseYouToMissTheStartOfYourTourOrCruise',
    defaultMessage: 'Did your missed connection cause you to miss the start of your tour or cruise?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/messages.js